<template>
    <span
        class="badge px-3 py-1 m-0"
        :class="computedAccuracyColor()"
        >{{ $tm(computedAccuracy()) }}</span
    >
</template>
<script setup lang="ts">
/**
 * This wrap the battery display so we can hide it on null
 */

const props = defineProps<{
    /**
     * the accuracy number
     */
    value: number | null;
}>();

const computedAccuracy = () => {
    if (!props.value) {
        return 'accuracy.unknown';
    }
    if (props.value < 0) {
        return 'accuracy.invalid';
    } else if (props.value < 8) {
        return 'accuracy.excellent';
    } else if (props.value < 20) {
        return 'accuracy.good';
    } else {
        return 'accuracy.poor';
    }
};

const computedAccuracyColor = () => {
    if (!props.value) {
        return '';
    }
    if (props.value < 0) {
        return 'bg-success text-white border border-success';
    } else if (props.value < 8) {
        return 'bg-success text-white border border-success';
    } else if (props.value < 20) {
        return 'bg-warning text-dark border border-warning';
    } else {
        return 'bg-danger text-white border border-danger';
    }
};
</script>
